import React, { ReactNode } from "react";

export function regReactChildren (props: any, element: ReactNode, index = 0) {
  props.children = React.Children.toArray(props.children);
  props.children.splice(index, 0, element);
}

export default regReactChildren;
